import { Menu } from '@headlessui/react'

type PropTypes = {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void
  children: React.ReactNode
}

const PopoverMenuItem = ({ onClick, children }: PropTypes) => {
  return (
    <Menu.Item>
      {({ active }) => (
        <button
          className={`${
            active ? 'bg-gray-700' : ''
          } group flex w-full items-center px-2 py-2 text-sm text-white rounded-[5px]`}
          onClick={onClick}
        >
          {children}
        </button>
      )}
    </Menu.Item>
  )
}

export default PopoverMenuItem
